import { render, staticRenderFns } from "./InApp.vue?vue&type=template&id=f6755638&scoped=true"
import script from "./InApp.vue?vue&type=script&lang=js"
export * from "./InApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6755638",
  null
  
)

export default component.exports